/**
 * Props compartilhadas para Drawers laterais sob o AppBar.
 * Usa --app-chrome-offset (publicado pelo MainLayout no :root).
 *
 * Importante: não sobrescrever `position` do Paper — o Drawer temporary
 * usa `position: fixed` + anchor (right/left). `relative` quebra o lado.
 */
export const BELOW_CHROME_DRAWER_PROPS = {
  ModalProps: {
    keepMounted: false,
    slotProps: {
      backdrop: {
        sx: {
          top: "var(--app-chrome-offset, 64px)",
        },
      },
    },
  },
  PaperProps: {
    sx: {
      top: "var(--app-chrome-offset, 64px) !important",
      height: "calc(100% - var(--app-chrome-offset, 64px)) !important",
      maxHeight: "calc(100% - var(--app-chrome-offset, 64px))",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
  },
};

export function belowChromeDrawerPaperSx(extraSx = {}) {
  return {
    ...BELOW_CHROME_DRAWER_PROPS.PaperProps.sx,
    ...extraSx,
  };
}
